// extracted by mini-css-extract-plugin
export default {"colors":"\"../../../styles/variables/colors.module.css\"","color-red400":"#e11e1d","active":"BookmarkButton_active__jManF"};